import axios from "axios";
import { APICore } from "./apiCore";

const api = new APICore();

function getAllRentals(start_date?: string, user?: string, status?: string) {
  const params: any = {};

  if (start_date) params.start_date = start_date;
  if (user) params.user = user;
  if (status) params.status = status;

  const baseUrl = "/web/rentals";
  return api.get(`${baseUrl}`, params);
}

export { getAllRentals };
